<template>
  <el-drawer v-model="drawer" title="订单详情" size="80%" :direction="direction" :before-close="handleClose">
    <qc-container title="收货信息">
      <el-descriptions v-if="order" :column="1" border>
        <el-descriptions-item label-class-name="w100" label="收货人">
          {{ order.deliveryName }}&nbsp;&nbsp;{{ order.mobile }}&nbsp;&nbsp;{{ order.address }}
        </el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="收货方式">{{ order.groupType == 1 ? "自提" : "快递" }}
        </el-descriptions-item>
        <template v-if="order.express">
          <el-descriptions-item label-class-name="w100" label="物流公司">{{ order.expressDesc }}</el-descriptions-item>
          <el-descriptions-item label-class-name="w100" label="快递单号">{{ order.expressCode }}<span
              class="ml10 cp primary" @click="copyText(order.expressCode)">复制</span></el-descriptions-item>
        </template>
        <el-descriptions-item v-if="order.deliverTime" label-class-name="w100" label="发货时间">
          {{ order.deliverTime }}
        </el-descriptions-item>
        <el-descriptions-item v-if="order.receiveTime" label-class-name="w100" label="收货时间">
          {{ order.receiveTime }}
        </el-descriptions-item>
        <el-descriptions-item v-if="order.closeTime" label-class-name="w100" label="关闭时间">{{ order.closeTime }}
        </el-descriptions-item>
        <el-descriptions-item v-if="order.commentTime" label-class-name="w100" label="评论时间">
          {{ order.commentTime }}
        </el-descriptions-item>
      </el-descriptions>
    </qc-container>
    <qc-container v-if="order" title="订单信息" class="mt20">
      <el-descriptions :column="2" border>
        <el-descriptions-item label-class-name="w100" label="订单编号">{{ order.code }}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="创建时间">{{ order.createTime }}</el-descriptions-item>
        <el-descriptions-item v-if="order.express" label-class-name="w100" label="快递">{{ order.expressDesc }}
        </el-descriptions-item>
        <el-descriptions-item v-if="order.expressCode" label-class-name="w100" label="快递单号">
          {{ order.expressCode }}
        </el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="状态">{{ getOrderStatus(order) }}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="订单类型">{{ ['售卖', '租赁', '洗消'][order.goodsType] }}
        </el-descriptions-item>
        <template v-if="order.payTime">
          <el-descriptions-item label-class-name="w100" label="支付方式">{{ ['微信支付', '支付宝'][order.payType] }}
          </el-descriptions-item>
          <el-descriptions-item label-class-name="w100" label="支付时间">{{ order.payTime }}</el-descriptions-item>
        </template>

      </el-descriptions>
      <t-table class="mt20" border :header="tableHeader" :data="order.orderGoodsList">
        <template #before>
          <el-table-column label="商品名称">
            <template #default="scope">
              <div class="goods-tag">
                <img class="table-img" :src="filePath+scope.row.picture">
                <div class="flex-1 ml20">
                  <div class="bold">{{ scope.row.name }}</div>
                  <div>ID:{{ scope.row.code }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </template>
      </t-table>

      <div class="sumMoney">
        <div><strong>商品总金额：</strong>￥{{ order.money }}</div>
        <div><strong>运费：</strong>￥{{ order.freight || 0 }}</div>
        <div><strong>优惠：</strong>￥{{ order.discount || 0 }}</div>
        <div><strong>实付金额：</strong><span class="primary">￥{{ order.payMoney }} </span></div>
      </div>
    </qc-container>
    <qc-container v-if="orderEvaluate" title="订单评价" class="mt20">
      <el-descriptions :column="2" border>
        <el-descriptions-item label-class-name="w100" label="物流评分">
            <el-rate disabled :model-value="orderEvaluate.logistics"></el-rate>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="服务评分">
            <el-rate disabled :model-value="orderEvaluate.attitude"></el-rate>
        </el-descriptions-item>
      </el-descriptions>
      <t-table class="mt20" border :header="orderEvaluateHeader" :data="orderEvaluate.orderEvaluateGoodsList">
        <template #before>
          <el-table-column label="商品名称" width="340">
            <template #default="scope">
              <div class="goods-tag">
                <div class="flex-1">
                  <div class="bold">{{ scope.row.name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
            <el-table-column label="评价图片" min-width="160">
                <template #default="scope">
                    <image-show width="50" height="50" v-if="scope.row.evaluateGoodsPictureList&&scope.row.evaluateGoodsPictureList.length>0"  :images="scope.row.evaluateGoodsPictureList.map(item=>filePath+item.url)"></image-show>
                </template>
            </el-table-column>
          <el-table-column label="商品评分" width="160">
            <template #default="scope">
              <el-rate disabled :model-value="scope.row.score"></el-rate>
            </template>
          </el-table-column>
        </template>
        <template #default="scope">
          <b-button @click="doReply(scope.row)" v-if="!scope.row.replyContent">回复</b-button>
        </template>
      </t-table>
    </qc-container>
    <reply-evaluate ref="reply" @load="loadEvaluate"></reply-evaluate>

    <template #footer>
      <div style="flex: auto">
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import ReturnBox from "@/components/home/return-box.vue";
import TTable from "@/components/el/t-table.vue";
import BButton from "@/components/el/b-button.vue";
import ReplyEvaluate from "@view/order/op/reply-evaluate.vue";
import ImageShow from "@/components/base/image-show.vue";

export default {
  name: "order-info",
  components: {ImageShow, ReplyEvaluate, BButton, TTable, ReturnBox, QcContainer},
  data() {
    return {
      drawer: false,
      direction: "rtl",
      order: null,
      tableHeader: [
        {type: "property", label: "属性", width: 300},
        {prop: "money", label: "单价", width: 100},
        {prop: "count", label: "数量", width: 100}
      ],
      orderEvaluateHeader: [
        {prop: "content", label: "评论内容", minWidth: 200},
        {prop: "replyContent", label: "回复内容", minWidth: 200},
      ],
      orderEvaluate: null,
      id: "",
    }
  },
  mixins: [tableBase],
  methods: {
    doReply(row) {
      this.$refs.reply.open(row);
    },
    openDrawer(id) {
      this.id = id;
      this.findDetail();
      this.drawer = true;
    },
    handleClose() {
      this.drawer = false;
    },
    loadEvaluate() {
      this.simpleGet("/api/mgr/shop/business/order/getOrderEvaluate", {id: this.id}, res => {
        this.orderEvaluate = res.data;
      })
    },
    findDetail() {
      this.simpleGet("/api/mgr/shop/business/order/detail", {id: this.id}, result => {
        this.order = result.data;
        if (1 === result.data.isEvaluate) {
          this.loadEvaluate();
        }
      });
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.goods-tag {
  display: flex;

  .flex-1 div {
    line-height: 18px;
  }
}

.table-img {
  width: 50px;
  height: 50px;
}

.sumMoney {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  div {
    line-height: 40px;
  }
}
</style>
